import React from 'react';
import _ from 'lodash';
import styles from './Favorites.module.scss';
import { Lang, FAVORITES_ENTITIES } from 'shared/constants';
import { KnowledgeWrapperComponent } from '../knowledge/components/knowledge-row';
import { PandaHappy } from '../../../images';
import { ContactItemComponent } from '../../../components/contact-item/contact-item.component';
import { ScreenTitle } from 'src/components/design-system';
import { Loader } from '../../../components/core';

/**
 * The Favorites page body: contacts first, then knowledge items, or the empty hint.
 *
 * @param {object} props
 * @param {object} [props.lang] - `FAVORITES_SCREEN` strings. Default `Lang.FAVORITES_SCREEN`.
 * @param {object[]|null} [props.list] - Rows from `useFavoriteItems`, each with `entity`. Default `null` (shows the empty hint).
 * @param {boolean} [props.loading] - Shows a loader instead of the list. Default `false`.
 * @returns {JSX.Element}
 * @example
 * <FavoritesPageComponent lang={lang} list={list} loading={isLoading} />
 */
const FavoritesPageComponent = React.memo(function FavoritesPageComponent({
  lang = Lang.FAVORITES_SCREEN,
  list = null,
  loading = false,
}) {
  const renderItems = () => {
    if (loading) {
      return <Loader />;
    }

    if (_.isNull(list) || list.length === 0) {
      return (
        <div className={styles.descriptionWrapper}>
          <img src={PandaHappy} className={styles.doctor} alt={lang.HEADER} />
          <h4>{lang.CONTENT}</h4>
        </div>
      );
    }

    const contacts = list
      .filter(
        item =>
          item.entity === FAVORITES_ENTITIES.CONTACT || item.entity === FAVORITES_ENTITIES.USER,
      )
      .sort(
        (a, b) => a.firstName.localeCompare(b.firstName) || a.lastName.localeCompare(b.lastName),
      )
      .map(item => <ContactItemComponent key={item.id} contact={item} />);

    const knowledge = list
      .filter(item => item.entity === FAVORITES_ENTITIES.KNOWLEDGE)
      .map(item => <KnowledgeWrapperComponent key={item.id} item={item} light showSpecialty />);

    return (
      <div className={styles.items}>
        <ScreenTitle title={lang.HEADER} />
        {contacts}
        {knowledge}
      </div>
    );
  };

  return <div className={styles.root}>{renderItems()}</div>;
});

export { FavoritesPageComponent };
